const StorageKeys = {
  loginData: 'CURRENT_LOGIN_DATA_KEY',
};

export default StorageKeys;
